"use strict";

var _defineProperty2 = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");
var _classCallCheck = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty2(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Background = _interopRequireDefault(require("./Background"));
var _utils = require("../utils");
var _reactIntl = require("react-intl");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    default: e
  };
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var ButtonCell = /*#__PURE__*/function (_react$default$Compon) {
  function ButtonCell() {
    var _this;
    _classCallCheck(this, ButtonCell);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ButtonCell, [].concat(args));
    _defineProperty(_this, "state", {
      active: false // clicked or hovered
    });
    _defineProperty(_this, "setActive", function (active) {
      return function () {
        return _this.setState({
          active: active
        });
      };
    });
    _defineProperty(_this, "onClick", function () {
      var _this$props = _this.props,
        cell = _this$props.cell,
        logEvent = _this$props.logEvent,
        intl = _this$props.intl;
      logEvent('click', {
        cellId: cell.id,
        pageId: cell.page_id,
        languageCode: intl.locale
      });
      if (cell.action_uri) {
        _axios.default.post(cell.action_uri, {
          btn_id: cell.action_value
        }).catch(function (error) {
          return console.error('ButtonCell action failed', error);
        });
      }
      _this.setState({
        active: true
      });
    });
    return _this;
  }
  _inherits(ButtonCell, _react$default$Compon);
  return _createClass(ButtonCell, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      return (0, _utils.shouldCellComponentUpdate)(this.props, nextProps) || this.state !== nextState;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        defaultLanguage = _this$props2.defaultLanguage,
        intl = _this$props2.intl,
        cell = _this$props2.cell,
        project = _this$props2.project,
        uriTransformer = _this$props2.uriTransformer;
      var active = this.state.active;
      var style = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, this.props.style), {}, {
        width: '100%',
        height: '100%',
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column'
      }, !!cell.font ? {
        fontFamily: cell.font
      } : project.default_button_font ? {
        fontFamily: project.default_button_font
      } : {}), !!cell.text_size ? {
        fontSize: "".concat(cell.text_size, "em")
      } : project.default_button_text_size ? {
        fontSize: "".concat(project.default_button_text_size, "em")
      } : {}), active && cell.click_text_color ? {
        color: cell.click_text_color
      } : !!cell.text_color ? {
        color: cell.text_color
      } : project.default_button_text_color ? {
        color: project.default_button_text_color
      } : {}), ButtonCell.verticalAlign(cell.vertical_align)), ButtonCell.horizontalAlign(cell.horizontal_align));
      var opacityPercent = cell.opacity != null ? cell.opacity : project.default_button_opacity;
      var text = (0, _utils.i18nData)(cell, 'text', intl, defaultLanguage);
      var bgValue = _objectSpread(_objectSpread({}, cell), active && cell.click_background_color ? {
        button_background_type: 'color',
        button_background_color: cell.click_background_color
      } : {});
      var defaultValue = {
        button_background_type: project.default_button_background_type,
        button_background_image_uri: project.default_button_background_image_uri,
        button_background_color: project.default_button_background_color
      };
      var innerStyle = _objectSpread({
        position: 'relative',
        width: "".concat(cell.width_percentage || project.default_button_width_percentage, "%"),
        height: 'auto',
        display: 'flex',
        alignContent: 'center',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        margin: '0.3em',
        opacity: parseInt(opacityPercent) / 100
      }, ButtonCell.shape(cell, project.default_button_shape, project.default_button_width_percentage));
      return /*#__PURE__*/_react.default.createElement(_Background.default, {
        value: cell,
        uriTransformer: uriTransformer,
        onClick: this.onClick,
        onTouchStart: this.setActive(true),
        onMouseEnter: this.setActive(true),
        onMouseLeave: this.setActive(false)
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: style
      }, /*#__PURE__*/_react.default.createElement(_Background.default, {
        value: bgValue,
        defaultValue: defaultValue,
        uriTransformer: uriTransformer,
        style: innerStyle,
        cssImage: true,
        propsPrefix: 'button_'
      }, /*#__PURE__*/_react.default.createElement("span", {
        style: {
          lineHeight: "".concat(cell.line_height, "em")
        }
      }, text))));
    }
  }]);
}(_react.default.Component);
_defineProperty(ButtonCell, "verticalAlign", function (cellVerticalAlign) {
  switch (cellVerticalAlign) {
    case 'top':
      return {
        justifyContent: 'flex-start'
      };
    case 'bottom':
      return {
        justifyContent: 'flex-end'
      };
    case 'middle':
      return {
        justifyContent: 'center'
      };
    default:
      return {};
  }
});
_defineProperty(ButtonCell, "horizontalAlign", function (cellHorizontalAlign) {
  switch (cellHorizontalAlign) {
    case 'left':
      return {
        alignItems: 'flex-start'
      };
    case 'right':
      return {
        alignItems: 'flex-end'
      };
    case 'center':
      return {
        alignItems: 'center'
      };
    default:
      return {};
  }
});
_defineProperty(ButtonCell, "shape", function (cell, defaultShape, defaultWidthPercent) {
  var shape = cell.shape === 'default' ? defaultShape : cell.shape;
  switch (shape) {
    case 'rounded_rectangle':
      return {
        padding: '0.5em 0',
        borderRadius: '1em'
      };
    case 'circle':
      {
        var heightPercent = (cell.width_percentage || defaultWidthPercent) * cell.width / cell.height;
        return {
          height: "".concat(heightPercent, "%"),
          borderRadius: '50%'
        };
      }
    default:
      return {
        padding: '0.5em 0'
      };
  }
});
var _default = exports.default = (0, _reactIntl.injectIntl)(ButtonCell);